import React from 'react';
import { Grid, Box } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { COMMON_STYLES, COMMON_VALIDATION_ALIAS, COMMON_VALIDATION_OUTPUT_COLUMN } from './common/Constants';
import { OutputColumnField } from './common/fields/OutputColumnField';
import { TransformationHeading } from './common/fields/Heading';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'current_date',
  alias: '',
  df: '',
  transformations: [
    {
      outputColumn: '',
    },
  ],
};

const validationSchema = {
  ...COMMON_VALIDATION_ALIAS,
  ...COMMON_VALIDATION_OUTPUT_COLUMN,
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const renderField = ({ disableForm, errors }) => {
    return (
      <Grid container spacing={2}>
        <Grid item {...COMMON_STYLES.gridItem}>
          <OutputColumnField
            value={formField?.transformations?.[0].outputColumn}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[0].outputColumn = e.target.value;
              setFieldValue('transformations', newTransforms);
            }}
            disabled={disableForm}
            error={!!errors.outputColumn}
            helperText={errors?.outputColumn || 'Name for current date Column'}
          />
        </Grid>
      </Grid>
    );
  };
  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title="Current Date - Get today's date" disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
        hideAddButton
      />
    </Box>
  );
};

const NodeModal_CurrentDate = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    renderTransformationFields={renderTransformationFields}
    validationSchema={validationSchema}
    transformationType={INITIALSTATE.type}
    tranformationName="Current Date"
  />
);

export default NodeModal_CurrentDate;
